import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SpoolDto } from '../types/spool-local';
import { TabsContext } from '../Tabs';
import useIsMounted from '../../hooks/useIsMounted';
import { TableRow } from '../Table';
import SpoolsAccordionRow from './SpoolsAccordionRow';
import CollapsibleArea from '../CollapsibleArea';
import SpoolsAccordionContent from './SpoolsAccordionContent';
import appContext from '../../context/app/appContext';

type Props = {
    spoolDetails: SpoolDto;
    collapsed: boolean;
    toggle: (spoolAddress: string) => void;
    isActiveSpools?: boolean;
};

const Spools: React.FC<Props> = ({
    spoolDetails,
    collapsed,
    toggle,
    isActiveSpools = false,
}) => {
    const { setSelectedSpool } = useContext(appContext);

    const { updateHeight } = useContext(TabsContext);

    const [disabled, setDisabled] = useState(false);

    const isMounted = useIsMounted();

    const handleToggle = useCallback(() => {
        if (disabled) return;

        toggle(spoolDetails.address);
        setDisabled(true);
        setSelectedSpool(spoolDetails);
    }, [disabled, spoolDetails, toggle, setSelectedSpool]);

    useEffect(() => {
        updateHeight();

        const timeout = setTimeout(() => {
            isMounted() && setDisabled(false);
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [collapsed, updateHeight, isMounted]);

    return (
        <TableRow className={collapsed ? 'collapsed' : ''}>
            <SpoolsAccordionRow
                spoolDetails={spoolDetails}
                toggle={handleToggle}
                isActiveSpools={isActiveSpools}
            />
            <CollapsibleArea
                className='spools-accordion-content'
                collapsed={collapsed}
                unMountOnExit={true}
            >
                <SpoolsAccordionContent
                    rowCollapsed={collapsed}
                    spoolDetails={spoolDetails}
                />
            </CollapsibleArea>
        </TableRow>
    );
};

export default Spools;
